import { render, staticRenderFns } from "./BuktiGadai.vue?vue&type=template&id=607d5d30&scoped=true&"
import script from "./BuktiGadai.vue?vue&type=script&lang=js&"
export * from "./BuktiGadai.vue?vue&type=script&lang=js&"
import style0 from "./BuktiGadai.vue?vue&type=style&index=0&id=607d5d30&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "607d5d30",
  null
  
)

export default component.exports